import { useState } from 'react';
import {
    Box,
    Button,
    FormControl,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    Typography,
} from '@mui/material';
import { useUserProfileQuery } from 'app/store';
import RenewSecretKeyDialog from './renew-secret-key.dialog';
import { CopyIconButton } from 'components/copy-button/copy-icon-button';

export const SecurityKey = () => {
    const [open, setOpen] = useState(false);
    const [showToken, setShowToken] = useState(false);
    const { data: profile } = useUserProfileQuery();
    const token = profile?.secret_key || '';

    return (
        <>
            <Box
                sx={{
                    p: { xs: 2.25, md: 3 },
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 3,
                    bgcolor: 'background.paper',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        flexDirection: { xs: 'column', md: 'row' },
                        gap: 2.5,
                    }}
                >
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                        <Typography
                            className="font-yekan-heavy"
                            sx={{ fontSize: { xs: 15, md: 17 } }}
                        >
                            توکن وب سرویس
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ mt: 0.75, color: 'text.secondary', lineHeight: 2 }}
                        >
                            از این توکن برای دسترسی به وب‌سرویس‌های حساب خود استفاده
                            کنید. با بروزرسانی توکن، مقدار قبلی بلافاصله نامعتبر می‌شود.
                        </Typography>
                    </Box>

                    <Button
                        variant="outlined"
                        color="warning"
                        startIcon={<i className="fa-light fa-rotate" />}
                        onClick={() => setOpen(true)}
                        sx={{ flexShrink: 0 }}
                    >
                        بروزرسانی توکن
                    </Button>
                </Box>

                <FormControl className="phone-from-control" fullWidth sx={{ mt: 2.5 }}>
                    <InputLabel
                        htmlFor="web-service-token"
                        className="font-yekan-heavy"
                    >
                        توکن وب سرویس
                    </InputLabel>

                    <OutlinedInput
                        id="web-service-token"
                        label="توکن وب سرویس"
                        readOnly
                        value={
                            showToken
                                ? token
                                : token
                                  ? '••••••••••••••••••••'
                                  : ''
                        }
                        placeholder="توکنی برای حساب ثبت نشده است"
                        inputProps={{
                            dir: 'ltr',
                            style: { textAlign: 'left' },
                        }}
                        startAdornment={
                            <InputAdornment position="start">
                                <CopyIconButton
                                    value={token}
                                    disabled={!token}
                                    size="small"
                                    aria-label="کپی توکن وب سرویس"
                                />
                            </InputAdornment>
                        }
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={() =>
                                        setShowToken((current) => !current)
                                    }
                                    disabled={!token}
                                    size="small"
                                    aria-label={
                                        showToken
                                            ? 'مخفی کردن توکن'
                                            : 'نمایش توکن'
                                    }
                                >
                                    <i
                                        className={
                                            showToken
                                                ? 'fa-light fa-eye-slash'
                                                : 'fa-light fa-eye'
                                        }
                                        style={{ fontSize: 16 }}
                                    />
                                </IconButton>
                            </InputAdornment>
                        }
                        sx={{
                            '.MuiInputBase-input': {
                                direction: 'ltr',
                                textAlign: 'left',
                                fontSize: '14px',
                                fontFamily: '"Roboto Mono", monospace',
                            },
                        }}
                    />
                </FormControl>
            </Box>

            <RenewSecretKeyDialog open={open} onClose={() => setOpen(false)} />
        </>
    );
};
